package com.demo.portfolio_demo.components.model

data class Trainings(
    val title: String,
    val topic: String,
    val organisation: String,
    val link: String,
)
